import { $, addAction, doAction } from '@situation/setdesign.util';

class Carousel {
    constructor($container) {
        this.$el = $container;
        const breakpoint = 992;

        this.handleChange = (event) => {
            let current = event.item.index - event.relatedTarget._clones.length / 2;
            current %= event.item.count;

            if (current < 0) {
                current = event.item.count + current;
            }

            $(window).trigger('scroll'); // Trigger lazy load on next item
            doAction('home-carousel/change', current);
        };

        const navText = [
            '<span class="prev-icon"><svg><use class="icon-use" '
                + 'xlink:href="#icon-chevron-left"></use></svg></span>',
            '<span class="next-icon"><svg><use class="icon-use" '
                + 'xlink:href="#icon-chevron-right"></use></svg></span>',
        ];
        const options = {
            items: 1,
            slideSpeed: 2000,
            autoplayTimeout: 5000,
            autoplay: true,
            loop: true,
            dots: false,
            navText,
            responsive: {},
        };
        options.responsive[0] = { nav: true };
        options.responsive[breakpoint] = { nav: false };
        this.$el.owlCarousel(options);
        this.$el
            .find('.home-slider-card__background--loading')
            .removeClass('home-slider-card__background--loading');

        this.$el.on('changed.owl.carousel', this.handleChange);
        doAction('home-carousel/change', 0);
        addAction('home-carousel/goto', this.goto, 10, this);
        addAction('home-carousel/pause', this.pause, 10, this);
        addAction('home-carousel/resume', this.resume, 10, this);
    }

    goto(index) {
        this.$el.trigger('to.owl.carousel', index);
    }

    pause() {
        this.$el.trigger('stop.owl.autoplay');
    }

    resume() {
        this.$el.trigger('play.owl.autoplay');
    }
}

export default Carousel;
